import type { SVGProps } from "react";
import { Icon, type IconProps } from "../Icon";
const InternalSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M18.78 8.78c0 3.72-3.628 7.553-5.576 9.526a1.685 1.685 0 0 1-2.408 0C8.849 16.333 5.22 12.5 5.22 8.78a6.78 6.78 0 1 1 13.56 0"
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M19.005 16.702c.927.543 1.47 1.2 1.47 1.908C20.475 20.482 16.68 22 12 22s-8.475-1.518-8.475-3.39c0-.708.543-1.365 1.47-1.908"
      style={{
        stroke: "var(--icon-accent,#E47B53)",
      }}
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M12 12.17a3.39 3.39 0 1 0 0-6.78 3.39 3.39 0 0 0 0 6.78"
    />
  </svg>
);
export const LocationIcon = (props: IconProps) => (
  <Icon {...props} Icon={InternalSvg} />
);
